/**
 * @fileoverview アプリケーション全体の設定ファイル
 * @description アプリケーションで使用する定数や設定値を一元管理します。
 *
 * このファイルでは、以下の設定を管理します：
 * - ブレークポイント（レスポンシブ対応）
 */

/**
 * レスポンシブデザインのブレークポイント設定
 * @description メディアクエリで使用するブレークポイントを定義
 * @type {Object<string, number>}
 */
window.APP_CONFIG = {
	BREAKPOINT: {
		SP: 768,
		TAB: 1024
	}
};